
import {Logbook} from './app/Logbook.js'
window.Logbook = Logbook;

import {Register} from './app/Register.js'
window.Register = Register;

import {Outro} from './app/Outro.js'
window.Outro = Outro;
